import API from 'services/TAPS_API';

export default function confirmRSP(data) {
  return API.request({
    method: 'POST',
    url: '/notification/paymentSearch/submit',
    data,
  });
}
